var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('html-brand-button',{attrs:{"link":_vm.appointmentLink.url,"target":_vm.appointmentLink.target}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }